export const ASSET = 'a';
export const CURRENCY = 'c';
export const CATEGORY = 'category';
export const DATE = 'date';
export const EXCHANGE = 'e';
export const EDIT_DASHBOARD = 'editDashboard';
export const FORMAT = 'f';
export const INTERVAL = 'i';
export const METRIC = 'm';
export const MINER = 'miner';
export const MODAL = 'modal';
export const MOVING_AVERAGE = 'mAvg';
export const MOVING_MEDIAN = 'mMedian';
export const PAYMENT_SUCCESS = 'paymentSuccess';
export const REDIRECT_TO = 'redirectTo';
export const RESOLUTION = 'resolution';
export const SAME_AXIS = 'sameAxis';
export const SCALE_METRIC = 'mScl';
export const SCALE_PRICE = 'pScl';
export const SINCE = 's';
export const UNTIL = 'u';
export const UPGRADE_PLAN = 'upgradePlan';
export const ZOOM = 'zoom';
export const TIMESTAMP_FORMAT = 'timestamp_format';
export const SECRET = 'secret';
